import { gql } from "@apollo/client";

import { AskAiChatMessageFragment } from "./get-ask-ai-session-query";

export default gql`
  ${AskAiChatMessageFragment}
  mutation editSuggestedAssessmentResponseMutation(
    $suggestionId: String!
    $chatSessionId: Int!
    $messageId: String!
  ) {
    editSuggestedAssessmentResponse(
      chatSessionId: $chatSessionId
      suggestionId: $suggestionId
      messageId: $messageId
    ) {
      chatSession {
        id
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
